import { Outlet, useRoutes, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import Layout from './Component/Layout'
import AboutUsPage from './Pages/Aboutus/Aboutus'
import BestPracticePage from './Pages/Aboutus/BestPractices'
import DistinctiveFeaturePage from './Pages/Aboutus/DistinctiveFeature'
import ActivityPage from './Pages/Activities/Activity'
import ALCNewsLetterView from './Pages/News_letter/newsletter.js'
import ContactUsPage from './Pages/Contactus/Contactus'
// import CoursePage from "./Pages/Course/Course";
// import CourseOfferingPage from "./Pages/Course_Offering/Course_Offering";
import CourseOfferedPage from './Pages/Department/Department.js'
import HomePage from './Pages/Home'
import FacultyPage from './Pages/Faculty/Faculty'
import NIRFComponentPage from './Pages/NIRF/NIRF.js'
import NIRFExtendedPage from './Pages/NIRF/NIRFExtended.js'
import NAACComponentPage from './Pages/NAAC/NAAC.js'
import NAACExtendedPage from './Pages/NAAC/NaccExtended.js'
import NAAC_Data from './Assets/JSON/NAAC/Naac.json'
import Extendednaacdata from './Assets/JSON/NAAC/NAACExtended_Data.json'
import FeedbackPage from './Pages/Feedback/Feedback'
import PlacementsPage from './Pages/Placements/placements'
import AboutIQACPage from './Pages/IQAC/AboutIQAC'
import IQACObjectivePage from './Pages/IQAC/IQAC_Objective'
import IQACParameterPage from './Pages/IQAC/IQAC_Parameters'
import QualityPolicyPage from './Pages/IQAC/Quality_Policy'
import MandatoryDocPage from './Pages/IQAC/Mandatory_doc'
import WorkingCommitteePage from './Pages/IQAC/Working_Commitee'
import InfrastructurePage from './Pages/Aboutus/Infrastructure'
import InstitutionalPolicy from './Pages/Aboutus/institutionalpolicy.js'
import AllStudentsPage from './Pages/Placements/allstudentsplacedlist'
import NotesList from './Pages/Academics/Notes/Notes'
import CoAndPoPage from './Pages/Academics/CosAndPos/coandpo'
import LibraryPage from './Pages/Academics/Library/library.js'
import IQACMeetings from './Pages/IQAC/IQAC_Meetings'
import StatutoryCommitteespage from './Pages/Committees/committees'
import NonStatutoryCommitteespage from './Pages/Committees/non_stat_committees'
import IQACDocumentsPage from './Pages/IQAC/IQAC_Documents'

import SocialBar from './Pages/Socialbar/Socialbar.js'

import MandatoryPDF from './Component/Pdfcomponents/mandatorypdf.js'
import IQACPDFView from './Component/Pdfcomponents/aboutIQACPDFViewer.js'
import Naacpdf from './Component/Pdfcomponents/fileviewer.js'
import NIRFPDF from './Component/Pdfcomponents/fileviewer.js'
import NaacuploadPdfViewer from './Component/Pdfcomponents/naacuploadpdf.js'
import ALCNewsLetterPDFView from './Component/Pdfcomponents/fileviewer.js'
import InstitutionalPolicyPDFView from './Component/Pdfcomponents/fileviewer.js'
import NotesView from './Component/Pdfcomponents/fileviewer.js'
import IQACMeetingsView from './Component/Pdfcomponents/fileviewer.js'
import CosAndPosView from './Component/Pdfcomponents/fileviewer.js'
import LibraryView from './Component/Pdfcomponents/fileviewer.js'
import BestPracticeView from './Component/Pdfcomponents/fileviewer.js'
import DistinctiveFeatureView from './Component/Pdfcomponents/fileviewer.js'
import NepIksIdpPage from './Pages/Aboutus/NepIksIdp'
import NepIksIdpView from './Component/Pdfcomponents/fileviewer.js'
import FacultyProfileView from './Component/Pdfcomponents/fileviewer.js'
import StatutoryCommitteesView from './Component/Pdfcomponents/fileviewer.js'
import NonStatutoryCommitteesView from './Component/Pdfcomponents/fileviewer.js'
import IQACDocumentsView from './Component/Pdfcomponents/fileviewer.js'

import Error404 from './Error404'
// import NCC from "./Pages/StudentCorner/NCC";
// import NSS from "./Pages/StudentCorner/NSS";
// import Sports from "./Pages/StudentCorner/Sports";

import './App.css'
import IQAC_Documents from './Pages/IQAC/IQAC_Documents'

const AppRoutes = () => {
  const location = useLocation()
  const ExtendedNaacData = Extendednaacdata.NaacExtended_Data

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  const routesNav = [
    { element: <HomePage />, path: '/' },
    { element: <HomePage />, path: '/home' },
    {
      element: <CourseOfferedPage />,
      path: '/courseoffering/:course/:subcourse',
    },
    // { element: <CoursePage />, path: "/course" },
    { element: <FacultyPage />, path: '/faculty' },
    { element: <AboutUsPage />, path: '/aboutus' },
    { element: <BestPracticePage />, path: '/bestpracticepage' },
    {
      element: (
        <BestPracticeView
          allowDownload={'false'}
          backPath={'/bestpracticepage'}
        />
      ),
      path: '/bestpracticepage/:docID/:pathurl',
    },
    { element: <DistinctiveFeaturePage />, path: '/distinctivefeaturepage' },
    {
      element: (
        <DistinctiveFeatureView
          allowDownload={'false'}
          backPath={'/distinctivefeaturepage'}
        />
      ),
      path: '/distinctivefeaturepage/:docID/:pathurl',
    },
    { element: <NepIksIdpPage />, path: '/nepiksidppage' },
    {
      element: (
        <NepIksIdpView allowDownload={'false'} backPath={'/nepiksidppage'} />
      ),
      path: '/nepiksidppage/:docID/:pathurl',
    },
    {
      element: (
        <FacultyProfileView allowDownload={'false'} backPath={'/faculty'} />
      ),
      path: '/faculty/:docID/:pathurl',
    },
    { element: <MandatoryPDF />, path: '/mandatorydoc/:id/:pathurl' },
    { element: <IQACPDFView />, path: '/aboutIQAC/:id/:pathurl' },
    { element: <ActivityPage />, path: '/activity' },
    { element: <ContactUsPage />, path: '/contactus' },
    { element: <IQACMeetings />, path: '/iqacmeetings' },
    {
      element: (
        <IQACMeetingsView allowDownload={'false'} backPath={'/iqacmeetings'} />
      ),
      path: '/iqacmeetings/:docID/:pathurl',
    },
    {
      element: (
        <IQACDocumentsView
          allowDownload={'false'}
          backPath={'/IQACDocuments'}
        />
      ),
      path: '/IQACDocuments/:docID/:pathurl',
    },
    { element: <NIRFComponentPage />, path: '/nirf' },
    {
      element: <NIRFPDF backPath={'/nirf'} allowDownload={'true'} />,
      path: '/nirf/:docID/:pathurl',
    },
    { element: <NIRFExtendedPage />, path: '/NIRFExtended' },
    { element: <NAACComponentPage />, path: '/naac' },
    { element: <NAACExtendedPage />, path: '/NAACExtended/:id/:name' },
    {
      element: (
        <Naacpdf data={NAAC_Data} backPath={'/naac'} allowDownload={'true'} />
      ),
      path: '/naac/:id/:pathname',
    },
    {
      element: (
        <Naacpdf
          data={ExtendedNaacData}
          backPath="/NAACExtended/11/Student"
          allowDownload={'true'}
        />
      ),
      path: '/extendednaac/:id/:pathname',
    },
    {
      element: <NaacuploadPdfViewer />,
      path: '/naacdocs/:conatiner/:year/:course/:pathurl',
    },
    { element: <NaacuploadPdfViewer />, path: '/naacdocs/:conatiner/:pathurl' },
    { element: <ALCNewsLetterView />, path: '/alcnewsletter' },
    {
      element: (
        <ALCNewsLetterPDFView
          allowDownload={'true'}
          backPath={'/alcnewsletter'}
        />
      ),
      path: '/alcnewsletter/:docID/:pathurl',
    },
    { element: <StatutoryCommitteespage />, path: '/statutorycommittees' },
    {
      element: (
        <StatutoryCommitteesView
          allowDownload={'false'}
          backPath={'/statutorycommittees'}
        />
      ),
      path: '/statutorycommittees/:docID/:pathurl',
    },
    { element: <NonStatutoryCommitteespage />, path: '/nonstatutorycommittees' },
    {
      element: (
        <NonStatutoryCommitteesView
          allowDownload={'false'}
          backPath={'/nonstatutorycommittees'}
        />
      ),
      path: '/nonstatutorycommittees/:docID/:pathurl',
    },
    { element: <NotesList />, path: '/notes' },
    {
      element: <NotesView allowDownload={'false'} backPath={'/notes'} />,
      path: '/notes/:docID/:pathurl',
    },
    { element: <CoAndPoPage />, path: '/co&po' },
    {
      element: <CosAndPosView allowDownload={'false'} backPath={'/co&po'} />,
      path: '/co&po/:docID/:pathurl',
    },
    { element: <LibraryPage />, path: '/library' },
    {
      element: <LibraryView allowDownload={'false'} backPath={'/library'} />,
      path: '/library/:docID/:pathurl',
    },    

    { element: <AboutIQACPage />, path: '/aboutIQAC' },
    { element: <IQACObjectivePage />, path: '/IQACObjective' },
    { element: <IQACParameterPage />, path: '/IQACParameter' },
    { element: <QualityPolicyPage />, path: '/Qualitypolicy' },
    { element: <MandatoryDocPage />, path: '/mandatorydoc' },
    { element: <WorkingCommitteePage />, path: '/workingcommitee' },
    { element: <IQACDocumentsPage />, path: '/IQACDocuments' },
    { element: <FeedbackPage />, path: '/feedback' },
    { element: <InfrastructurePage />, path: '/infrastructure' },
    {
      element: <InstitutionalPolicy />,
      path: '/institutionalpolicy',
    },
    {
      element: (
        <InstitutionalPolicyPDFView
          backPath={'/alcnewsletter'}
          allowDownload={'false'}
        />
      ),
      path: '/institutionalpolicy/:docID/:pathurl',
    },
    { element: <PlacementsPage />, path: '/placements' },
    { element: <AllStudentsPage />, path: '/allStudents' },
    { element: <Error404 />, path: '*' },

    // { element: <NCC />, path: "/NCC" },
    // { element: <NSS />, path: "/NSS" },
    // { element: <Sports />, path: "/sports" },
  ]

  const routesData = [
    {
      element: <Layout />,
      children: [
        {
          element: <Outlet />,
          children: routesNav,
        },
      ],
    },
  ]

  return (
    <div>
      {' '}
      {/* Use a container for styling */}
      {useRoutes(routesData)}
      <SocialBar />
    </div>
  )
}

export default AppRoutes
